export default __webpack_public_path__ + "static/pro@mob-596ee23698bdd9b7d0ca2fc4d33aa221.png";